import { CustomFormApiTypes } from 'apis/customForms/types';

import { FormSubmissionData } from '../../customForms.types';

export const formSubmissionConverter = {
  toInternal: transformApiTypesToInternalTypes,
};

function transformApiTypesToInternalTypes(
  formSubmission: CustomFormApiTypes['FormSubmission'],
): FormSubmissionData {
  return {
    submissionId: formSubmission.id,
    formId: formSubmission.form_id,
    formVersion: formSubmission.form_version.toString(),
    submissionData: formSubmission.values.reduce((acc, value) => {
      acc[value.attribute_id] = value.value.value;
      return acc;
    }, {} as Record<string, string | string[] | undefined>),
  };
}
